<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" lg="4">
        <v-row class="mt-n2" dense>
          <v-col cols="5">
            <v-select
              dense 
              :items="errorFilterValues" 
              v-model="errorFilter" 
              class="mt-2 t-error-select"
              :disabled="portionLoading" />
          </v-col>
          <v-col cols="7">
            <v-layout d-flex align-baseline>
              <v-text-field
                dense 
                :label="$t('rights.search')"
                v-model="searchQuery"
                :disabled="portionLoading" 
                @keydown.enter.prevent="doSearch" 
                class="t-search-query" />
                <v-btn class="ml-2" @click="doSearch" :disabled="portionLoading">
                  <v-icon left>
                    mdi-magnify
                  </v-icon>
                  {{ $t('rights.search') }}
              </v-btn>
            </v-layout>
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="12" lg="8" class="py-0 py-lg-4 my-n4">
        <v-toolbar class="shrink-bar float-right" dense elevation="0">

          <v-tooltip top>
            <template v-slot:activator="tooltipScope">
              <v-btn v-bind="tooltipScope.attrs" v-on="tooltipScope.on" :disabled="portionLoading" :small="$vuetify.breakpoint.smAndDown" class="mx-1 my-2" color="success" @click="addRightVisible = true">
                <v-icon :left="$vuetify.breakpoint.smAndUp" color="white">mdi-plus</v-icon>
                <span v-if="$vuetify.breakpoint.smAndUp" class="text--white">{{ $vuetify.breakpoint.mdAndDown ? $t('rights.create') : $t('rights.create') }} </span>
              </v-btn>
            </template>
            <span>{{ $t('rights.createTooltip') }}</span>
          </v-tooltip>

          <v-menu :close-on-content-click="false">
            <template v-slot:activator="menuScope">
              <v-tooltip top>
                <template v-slot:activator="tooltipScope">
                  <v-btn v-on="{ ...menuScope.on, ...tooltipScope.on }" :disabled="portionLoading" :small="$vuetify.breakpoint.smAndDown" class="mx-1 my-2">
                    <v-icon :left="$vuetify.breakpoint.smAndUp">mdi-view-column</v-icon>
                    <span v-if="$vuetify.breakpoint.smAndUp">{{ $vuetify.breakpoint.mdAndDown ? $t('rights.columnsButtonShort') : $t('rights.columnsButton') }}</span>
                  </v-btn>
                </template>
                <span>{{ $t('rights.columnsButtonTooltip') }}</span>
              </v-tooltip>
            </template>

            <v-list dense>
              <v-list-item v-for="col in additionalColumns" :key="col.value">
                <v-list-item-action>
                  <v-checkbox
                    :input-value="selectedColumns.includes(col.value)"
                    @change="toggleColumnSelect(col.value)"
                  ></v-checkbox>
                </v-list-item-action>
                <v-list-item-content>
                  {{ col.text }}
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>

          <v-tooltip top>
            <template v-slot:activator="tooltipScope">
              <v-btn v-on="tooltipScope.on" :small="$vuetify.breakpoint.smAndDown" class="mx-1 my-2" color="primary" @click="editFormVisible = true" :disabled="portionLoading || checkedItems.length === 0">
              <v-icon :left="$vuetify.breakpoint.smAndUp">mdi-pencil</v-icon>
              <span v-if="$vuetify.breakpoint.smAndUp">{{ $vuetify.breakpoint.mdAndDown ? $t('rights.editShort') : $t('rights.edit')}}</span>
            </v-btn>
            </template>
            <span>{{ $t('rights.editTooltip') }}</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="tooltipScope">
              <v-btn v-on="tooltipScope.on" :small="$vuetify.breakpoint.smAndDown" class="mx-1 my-2" color="primary" @click="onRemoveItems" :disabled="portionLoading || checkedItems.length === 0">
                <v-icon :left="$vuetify.breakpoint.smAndUp">mdi-delete</v-icon>
                <span v-if="$vuetify.breakpoint.smAndUp">{{ $vuetify.breakpoint.mdAndDown ? $t('staging.removeShort') : $t('staging.remove')}}</span>
              </v-btn>
            </template>
            <span>{{ $t('staging.removeTooltip') }}</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="tooltipScope">
              <v-btn v-on="tooltipScope.on" :small="$vuetify.breakpoint.smAndDown" class="mx-1 my-2"  color="primary" :disabled="portionLoading || checkedItems.length === 0" @click="onRevokeItems">
                <v-icon :left="$vuetify.breakpoint.smAndUp">mdi-undo</v-icon>
                <span v-if="$vuetify.breakpoint.smAndUp">{{ $vuetify.breakpoint.mdAndDown ? $t('staging.revokeShort') : $t('staging.revoke')}}</span>
              </v-btn>
            </template>
            <span>{{ $t('staging.revokeTooltip') }}</span>
          </v-tooltip>

        </v-toolbar>
      </v-col>
    </v-row>

    <v-row class="mt-2 mt-lg-n6">
      <v-col>
        <v-toolbar class="shrink-bar float-right" dense elevation="0">

          <v-tooltip top>
            <template v-slot:activator="tooltipScope">
              <v-btn v-on="tooltipScope.on" :small="$vuetify.breakpoint.smAndDown" class="mx-1 my-2" :disabled="portionLoading || checkedItems.length === 0" @click="onCreateClaimForm">
                <v-icon :left="$vuetify.breakpoint.smAndUp">mdi-check</v-icon>
                <span v-if="$vuetify.breakpoint.smAndUp">{{ $vuetify.breakpoint.mdAndDown ? $t('staging.claimform.buttonShort') : $t('staging.claimform.button') }}</span>
              </v-btn>
            </template>
            <span>{{ $t('staging.claimform.buttonTooltip') }}</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="tooltipScope">
              <v-btn v-on="tooltipScope.on" :disabled="portionLoading" :small="$vuetify.breakpoint.smAndDown" class="mx-1 my-2" color="success" @click="uploadPopup = true">
                <v-icon :left="$vuetify.breakpoint.smAndUp" color="white">mdi-upload</v-icon>
                <span v-if="$vuetify.breakpoint.smAndUp" class="text--white">{{ $vuetify.breakpoint.mdAndDown ? $t('rights.upload_xlsShort') : $t('rights.upload_xls') }}</span>
              </v-btn>
            </template>
            <span>{{ $t('rights.upload_xlsTooltip') }}</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="tooltipScope">
              <v-btn v-on="tooltipScope.on" :disabled="portionLoading" :small="$vuetify.breakpoint.smAndDown" class="mx-1 my-2" color="success" @click="spotifyPopup = true">
                <v-icon :left="$vuetify.breakpoint.smAndUp" color="white">mdi-content-copy</v-icon>
                <span v-if="$vuetify.breakpoint.smAndUp" class="text--white">{{ $vuetify.breakpoint.mdAndDown ? $t('rights.upload_spotifyShort') : $t('rights.upload_spotify') }} </span>
              </v-btn>
            </template>
            <span>{{ $t('rights.upload_spotifyTooltip') }}</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="tooltipScope">
              <v-btn v-on="tooltipScope.on" :disabled="portionLoading" :small="$vuetify.breakpoint.smAndDown" class="mx-1 my-2" color="success" @click="reloadItems">
                <v-icon :left="$vuetify.breakpoint.smAndUp" color="white">mdi-reload</v-icon>
                <span v-if="$vuetify.breakpoint.smAndUp" class="text--white">{{ $vuetify.breakpoint.mdAndDown ? $t('staging.claimform.reloadShort') : $t('staging.claimform.reload') }}</span>
              </v-btn>
            </template>
            <span>{{ $t('staging.claimform.reloadTooltip') }}</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="tooltipScope">
              <v-btn v-on="tooltipScope.on"  :small="$vuetify.breakpoint.smAndDown" class="mx-1 my-2" color="primary" @click="onRemoveAllItems" :disabled="portionLoading || Lget(staging, 'list.length', 0) === 0">
                <v-icon :left="$vuetify.breakpoint.smAndUp">mdi-delete-forever</v-icon>
                <span v-if="$vuetify.breakpoint.smAndUp">{{ $vuetify.breakpoint.mdAndDown ? $t('staging.removeAllShort') : $t('staging.removeAll')}}</span>
              </v-btn>
            </template>
            <span>{{ $t('staging.removeAllTooltip') }}</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="tooltipScope">
              <v-btn v-on="tooltipScope.on" :disabled="portionLoading || downloading || Lget(staging, 'list.length', 0) === 0" :small="$vuetify.breakpoint.smAndDown" class="mx-1 my-2" color="primary" @click="onDownloadItems">
                <v-icon v-if="downloading" :left="$vuetify.breakpoint.smAndUp">mdi-loading mdi-spin</v-icon>
                <v-icon v-else :left="$vuetify.breakpoint.smAndUp">mdi-download</v-icon>
                <span v-if="$vuetify.breakpoint.smAndUp">{{ $vuetify.breakpoint.mdAndDown ? $t('rights.downloadShort') : $t('rights.download') }}</span>
              </v-btn>
            </template>
            <span>{{ $t('rights.downloadTooltip') }}</span>
          </v-tooltip>


        </v-toolbar>
      </v-col>
    </v-row>

    <RightsTable
      :continuos-amount="!staging.finished"
      :portion-loading="portionLoading"
      :checked-items.sync="checkedItems"
      :items="rightsList"
      :displayed-columns="displayedColumns"
      :errors="errors"
      :total-count="staging.totalCount"
      @load-errors="loadErrors"
    />

    <v-dialog v-model="uploadPopup" width="500px" :max-width="$vuetify.breakpoint.mobile ? '95%' : '30%'" persistent>
      <v-card>
        <v-card-title>
          {{ $t('staging.uploadForm.title') }}
        </v-card-title>

        <v-card-subtitle v-if="upload.loading">
          {{ $t('staging.uploadForm.subtitle.loading') }}
        </v-card-subtitle>
        <v-card-subtitle v-else>
          {{ useDnD ? $t('staging.uploadForm.subtitle.dnd') : $t('staging.uploadForm.subtitle.select') }}
        </v-card-subtitle>

        <v-card-text v-if="!upload.loading">
          <p><a href="#" @click.prevent="onDownloadTemplate">{{  $t('staging.uploadForm.example') }}</a></p>

          <v-card v-if="useDnD" class="droparea"
            @drop.prevent="onDrop($event)"
            @dragover.prevent="dragover = true"
            @dragenter.prevent="dragover = true"
            @dragleave.prevent="dragover = false"
            :class="{ 'grey lighten-2': dragover }">
            <v-card-text>
              <v-row class="d-flex flex-column" dense align="center" justify="center">
                <v-icon :class="[dragover ? 'mt-2, mb-6' : 'mt-5']" size="60">
                  mdi-cloud-upload
                </v-icon>
                <p>
                  {{ $t('staging.addForm.drop_files_here') }}
                </p>
              </v-row>
              <v-virtual-scroll
                v-if="droppedFiles.length > 0"
                :items="droppedFiles"
                height="150"
                item-height="50"
              >
                <template v-slot:default="{ item }">
                  <v-list-item :key="item">
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ item.name }}
                      </v-list-item-title>
                    </v-list-item-content>

                    <v-list-item-action>
                      <v-btn @click.stop="removeFile(item)" icon>
                        <v-icon> mdi-close-circle </v-icon>
                      </v-btn>
                    </v-list-item-action>
                  </v-list-item>

                  <v-divider></v-divider>
                </template>
              </v-virtual-scroll>
            </v-card-text>
            <v-card-text class="d-flex">
              <v-spacer></v-spacer>
              <template v-if="droppedFiles.length">
                {{ droppedFiles.length + ' ' + $t('staging.addForm.num_files') }}
              </template>
            </v-card-text>
          </v-card>

          <v-file-input v-else
            v-model="upload.files"
            multiple
            :label="$t('staging.uploadForm.label')"
            accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          />

          <v-container class="mb-6 mt-n2 mr-n6">
            <v-btn class="float-right" text @click="switchDnDMode">
              {{ useDnD ? $t('staging.uploadForm.switchToSelect') : $t('staging.uploadForm.switchToDnD') }}
            </v-btn>
          </v-container>

          <v-switch v-model="upload.revoke" :label="$t('staging.uploadForm.revoke')"/>
          <v-switch v-model="upload.commit" :label="$t('staging.uploadForm.commit')"/>
        </v-card-text>

        <v-divider/>
        <v-card-actions v-if="upload.loading">
          <v-progress-linear color="primary" indeterminate/>
        </v-card-actions>
        <v-card-actions v-else>
          <v-btn text color="primary" @click="onUploadFile" :disabled="(!useDnD && !upload.files.length) || (useDnD && !droppedFiles.length)">{{
              $t('staging.uploadForm.upload')
            }}
          </v-btn>
          <v-spacer/>
          <v-btn text color="secondary" @click="uploadPopup = false">{{ $t('staging.uploadForm.cancel') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog width="600px" :max-width="$vuetify.breakpoint.mobile ? '95%' : '30%'" v-model="spotifyPopup">
      <AddRightSpotifyForm
        v-if="spotifyPopup"
        @cancel="spotifyPopup = false"
        @save="onSpotifyPopupFinished"
      />
    </v-dialog>


    <v-dialog v-model="editFormVisible" :max-width="$vuetify.breakpoint.mobile ? '95%' : '60%'" persistent>
      <EditRightForm
        v-if="editFormVisible"
        :items="checkedItems"
        :actions-loading="editInProcess"
        :actions-loading-progress="editProgress.value"
        @close="editFormVisible = false"
        @save="onRightsEdit"
      >

      </EditRightForm>
    </v-dialog>

    <v-dialog :width="$vuetify.breakpoint.mobile ? '95%' : '50%'" :value="editInProcess">
      <v-card>
        <v-card-text>
          <span>{{ $t('staging.edit.inProcess') }}</span>
          <v-progress-linear color="primary" :indeterminate="editProgress.value < 0" :value="editProgress.value * 100"/>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog :width="$vuetify.breakpoint.mobile ? '95%' : '50%'" max-width="1000px" v-model="addRightVisible">
      <AddRightForm
        v-if="addRightVisible"
        @cancel="addRightVisible = false"
        @save="onCreateRightFinished"
      />
    </v-dialog>

  </v-container>
</template>

<script>
import {mapGetters} from "vuex";
import RightsholderInitedDataDrivenMixin from "@/components/mixins/RightsholderInitedDataDrivenMixin";
import RightsTable from "@/components/rights/RightsTable";
import DebounceSearchLauncherMixin from "@/components/mixins/DebounceSearchLauncherMixin";
import EditRightForm from "@/components/rights/EditRightForm";
import CreateRightButtonMixin from "@/components/mixins/CreateRightButtonMixin";
import SelectedColumnsStore from "@/components/mixins/SelectedColumnsStoreMixin";
import AddRightForm from "@/components/rights/AddRightForm";
import AddRightSpotifyForm from "@/components/rights/AddRightSpotifyForm";
import downloadFile from "@/utils/downloadFile";
import Lget from 'lodash/get'

export default {
  name: 'StagingArea',
  components: {AddRightForm, EditRightForm, RightsTable, AddRightSpotifyForm},
  data() {
    return {
      uploadPopup: false,
      portionLoading: false,
      checkedItems: [],
      errorFilter: 'all',
      errors: {},
      editFormVisible: false,
      editInProcess: false,
      editProgress: {
        value: 0
      },
      selectedColumns: [],
      selectedColumnsStore: 'stagingAreaColumns',
      upload: {
        revoke: false,
        commit: true,
        files: [],
        loading: false,
      },
      columnHeadings: [],
      spotifyPopup: false,
      downloading: false,

      useDnD: true,
      dragover: false,
      droppedFiles: []
    }
  },
  mixins: [SelectedColumnsStore, DebounceSearchLauncherMixin, RightsholderInitedDataDrivenMixin, CreateRightButtonMixin],
  computed: {
    ...mapGetters('app', ['staging','currentRightsholder']),
    rightsList() {
      if (!this.staging.list) {
        return [];
      }
      const list = this.staging.list;

      const noErrors = this.errorFilter === 'no-errors';
      return this.errorFilter === 'all' ? list : list.filter(({hasError}) => (noErrors ? !hasError : hasError));
    },
    allColumns() {
      return [
        'revoke',
        'rowNumber',
        'hasError',
        'type',
        'isrc',
        'spnr',
        'artistName',
        'title',
        'countryCode',
        'companyCountryCode',
        'secondaryCountryCode',
        'year',
        'claimStartDate',
        'claimEndDate',
        'labelName',
        'status',
        'version',
        'externalId',
        'grp',
        'file'
      ].concat(this.currentRightsholder.internationalCollectionAllowed ? ['internationalCollection'] : []);
    },
    errorFilterValues() {
      return ['all', 'errors', 'no-errors'].map((value) => ({value, text: this.$t(`staging.errorFilters.${value}`)}))
    },

    displayedColumns() {
      return this.allColumns.filter((col) => (this.additionalColumns.some(({value}) => value === col) ? this.selectedColumns.includes(col) : true));
    },

    additionalColumns() {
      const getCol = (value) => ({value, text: this.$t(`rights.columns.${value}`)})
      return ['rowNumber', 'spnr', 'version', 'year', 'companyCountryCode', 'secondaryCountryCode', 'labelName', 'grp', 'file'].map(getCol);
    }
  },

  methods: {

    // For Lodash get i template
    Lget,

    // Mixin override
    reloadItems() {
      this.loadItems(true);
    },

    // Do search
    doSearch() {
      this.loadItems(true);
    },

    // Override
    searchQueryUpdated() {
      // this.loadItems(true);
    },

    loadItems(force) {
      if (!this.portionLoading) {
        this.portionLoading = true;
        return this.$store.dispatch('app/loadStagingRows', {
          reload: force,
          search: this.searchQuery
        })
          .then(res => {
            if (res && res.headings) {
              this.columnHeadings = res.headings.reduce((res, curr) => ({...res, ...curr}), {});
            }
          })
          .catch((err) => {
            this.$toast(err.message)
          })
          .finally(() => {
            this.portionLoading = false;
          })
      }
      return Promise.resolve('Already loading')
    },

    onRemoveItems() {
      this.$dialog.confirm({
        text: this.$t("staging.confirmDelete", [this.checkedItems.length])
      })
        .then((response) => {
          if (response) {
            this.removeItems();
          }
        })
    },

    onRemoveAllItems() {
      this.$dialog.confirm({
        text: this.$t("staging.confirmDelete", [this.staging.list.length])
      })
        .then((response) => {
          if (response) {
            this.removeAllItems();
          }
        })
    },

    removeAllItems() {
      this.$store.dispatch('app/removeStagingRows', this.staging.list)
        .then(() => {
          this.checkedItems = [];
        })
    },

    removeItems() {
      this.$store.dispatch('app/removeStagingRows', this.checkedItems)
        .then(() => {
          this.checkedItems = [];
        })
    },

    onRevokeItems() {
      this.$dialog.confirm({
        text: 'Are you sure to revoke these items?'
      })
        .then((res) => {
          if (res) {
            this.revokeItems();
          }
        })
    },

    revokeItems() {
      this.$store.dispatch('app/revokeRights', {items: this.checkedItems})
        .then(() => {
          this.reloadItems();
          this.checkedItems = [];
        })
    },

    toggleColumnSelect(col) {
      if (this.selectedColumns.includes(col)) {
        this.selectedColumns = this.selectedColumns.filter(c => c !== col);
      } else {
        this.selectedColumns.push(col);
      }
    },

    loadErrors(item) {
      const id = String(item.id);
      if (item.errors) {
        return;
      }
      item.errors = [];
      const field = (err, lang) => this.columnHeadings[err.field]?.label[lang] || err.field;
      const displayedErrors = item.error.map((err) => ({en: `[${field(err, 'En')}] ${err.errormsg.en}`, sv: `[${field(err, 'Sv')}] ${err.errormsg.sv}` }));
      this.$set(this.errors, id, displayedErrors);
    },

    onRightsEdit(data) {
      const launchEdit = (items) => {
        this.editInProcess = true;
        this.editProgress = {value: 0};
        return this.$store.dispatch('app/editRightsList', {items, progressObservable: this.editProgress})
          .then((res) => {
            setTimeout(() => {
              this.checkedItems = [];
              this.editFormVisible = false;
              this.editInProcess = false;
              this.$toast(this.$t('staging.edit.success', [res.data.count]));
              this.reloadItems();
            }, 1000);
          })
          .catch((err) => {
            console.error(err);
            this.$toast(this.$t('staging.edit.error'));
            this.editInProcess = false;
          })
      }

      switch (data.mode) {
        case 'list': {
          if (data.items.length) {
            launchEdit(data.items);
          } else {
            this.$toast(this.$t('rights.editForm.noItems'))
          }
          break;
        }
        case 'field': {
          if (Object.keys(data.item).length > 0) {
            const list = data.targets.map(({ityp, isrc, spnr}) => ({ityp, isrc, spnr, ...data.item}));
            launchEdit(list);
          } else {
            this.$toast(this.$t('rights.editForm.noChangesToApply'))
          }
        }
      }
    },

    onCreateClaimForm() {
      this.$dialog.prompt({
        title: this.$t('staging.claimform.title'),
      })
        .then((res) => {
          if (res === false) {
            // Closed
            return;
          }
          if (res) {
            this.editProgress = {value: 0};
            this.editInProcess = true;
            this.$store.dispatch('app/createClaimform', {
              title: res,
              items: this.checkedItems,
              progressObservable: this.editProgress
            })
              .then(() => {
                this.reloadItems();
                this.checkedItems = [];
              })
              .finally(() => {
                this.editInProcess = false;
              })
          } else {
            this.$toast(this.$t('staging.claimform.emptyName'));
          }
        })
    },

    onUploadFile() {
      if (this.useDnD) {
        this.upload.files = this.droppedFiles
      }
      this.upload.loading = true;
      this.$store.dispatch('app/uploadFileToStaging', this.upload)
        .then(() => {
          this.$toast(this.$t('staging.uploadForm.done'))
        })
        .finally(() => {
          this.upload = {
            files: [],
            loading: false,
            revoke: false,
            commit: false
          };
          this.droppedFiles = []
          this.uploadPopup = false;
        })
    },

    onDownloadItems() {
      this.downloading = true
      this.$store.dispatch('app/getStagingDownloadUrl',{search: this.searchQuery, format: 'xlsx'})
        .then((res) => {
          downloadFile((res.filename ? res.filename : 'staging.xlsx'), res.url);
          this.downloading = false
        })
    },

    onCreateRightFinished(data) {
      this.onCreateRight(data)
        .then(() => {
          this.addRightVisible = false;
          this.reloadItems();
        })
    },

    onSpotifyPopupFinished(data) {
      this.onCreateRight(data)
        .then(() => {
          this.spotifyPopup = false;
          this.reloadItems();
        })
    },


    onDownloadTemplate() {
      this.$store.dispatch('app/getXLSXTemplateUrl')
        .then((data) => {
          const lang = ((s) => s.replace(s[0], s[0].toUpperCase()))(this.$i18n.locale);
          const name = data.docname[lang];
          const uri = data.docuri[lang];
          const type = data.doctype;
          this.$store.dispatch('app/downloadPrivateDocument', {uri, type})
            .then((uri) => downloadFile(name, uri));
        })
    },

    switchDnDMode() {
      if (this.useDnD) {
        this.droppedFiles = []
      } else {
        this.upload.files = []
      }
      this.useDnD = !this.useDnD
    },

    removeFile(link) {
      const index = this.droppedFiles.findIndex(e => e === link)
      if (index > -1) this.droppedFiles.splice(index, 1)
    },

    onDrop(e) {
      this.dragover = false;
      try {
        console.log(e.dataTransfer.files)
        const files = e.dataTransfer.files
        const validRe = /.xls(x?)$/i
        files.forEach(element => {
          if (validRe.test(element.name)) {
            this.droppedFiles.push(element)
          }
        })
      } catch (error) {
        //
      }
    }

  },
}
</script>